<template>
  <div>
    <v-slide-group>
      <v-slide-item v-for="(sc, scIndex) in schemeList" :key="scIndex" class="my-2">
        <v-sheet
        dark
          color="primary"
          elevation="5"
          height="200"
          width="360"
          rounded
          class="pa-3 px-5 rounded-xl mr-3 d-flex flex-column justify-space-between"
        >
          <div class="my-1">
            <div class="d-flex justify-space-between">
              <div>
                <v-img
                  src="../../../assets/weSupport.png"
                  alt="We"
                  height="60"
                  width="60"
                ></v-img>
              </div>
              <div class="d-flex flex-column">
              <h4 class="text-right">{{ sc.schemeName }}</h4>
              <h6 class="text-center">{{ sc.enrollmentNumber }}</h6>
            </div>
            </div>
          </div>
          <!-- <div class="my-1 text-center">
            <label style="font-size: small;">Scheme Number</label>
            <h4 class="text-center">{{ sc.enrollmentNumber }}</h4>
            <h1>₹ {{(5000).toFixed(2)}}</h1>
          </div> -->
          <div class="d-flex justify-space-between my-1 mt-4">
            <div>
              
              <label style="font-size: small;">Membership Fee</label>
              <h4> ₹ {{ formatNumber(sc.schemeAmount) }}</h4>
              <!-- <h4>{{ sc.branchName }}</h4> -->
              <!-- <h4 style="font-size: small;">Membership Fee</h4> -->
              
            </div>
            <div >
              <label style="font-size: small;">Paid/Tenure</label>
              <h4>{{sc.totalPaid}}/{{ sc.totalInstallment }}</h4>
            </div>
          </div>
        </v-sheet>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
export default {
  data: () => ({
    schemeList: [],
    memId:"",
  }),
  props:{
    memberId:{
      type:String,
      required: true
    }
  },
  mounted() {
    this.getSchemes();
  },
  methods: {

    async getSchemes() {
      if(!this.memberId){
        await this.getMemId();
      }
      this.$emit("loadingChange",true);
      let url = `/api/wesupport/SchemeEnrollment/GetSchemeEnrolledListByMemberId?MemberId=${this.decryptMemId() || this.memId}`;
      callApi(url, "get", "")
        .then((res) => {
          this.schemeList = res.data.data;
        })
        .catch((err) => {})
        .finally(()=>{
          this.$emit("loadingChange",false);
        });
    },
    getMemId(){
      return new Promise((resolve)=>{
        let url = `/api/wesupport/Member/getMemIdByMobNumber?memberId=${this.decryptMemId() || this.memberId }`;
        callApi(url, "get", "")
        .then((res)=>{
          this.memId = res.data.data.id;
          resolve()
        })
        .catch((err)=>{
          resolve()
        })
      })
    },
  },
};
</script>
